import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconShoppingBagLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M6.308 21.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V8.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525H8.25v-.25c0-1.036.366-1.92 1.098-2.652A3.614 3.614 0 0 1 12 2.5c1.036 0 1.92.366 2.652 1.098A3.614 3.614 0 0 1 15.75 6.25v.25h1.942c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308Zm0-1.5h11.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212V8.308a.294.294 0 0 0-.096-.212.294.294 0 0 0-.212-.096H15.75v2.25a.725.725 0 0 1-.216.534A.725.725 0 0 1 15 11a.725.725 0 0 1-.534-.216.725.725 0 0 1-.216-.534V8h-4.5v2.25a.725.725 0 0 1-.216.534A.725.725 0 0 1 9 11a.725.725 0 0 1-.534-.216.725.725 0 0 1-.216-.534V8H6.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v11.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096ZM9.75 6.5h4.5v-.25c0-.627-.218-1.159-.655-1.595A2.171 2.171 0 0 0 12 4a2.17 2.17 0 0 0-1.595.655A2.171 2.171 0 0 0 9.75 6.25v.25Z"
      />
    </Svg>
  );
};

export default IconShoppingBagLine;
